import React from "react";
import SignupPage from "../../components/auth/SignupPage";

const SignupBusiness = () => {
  return <SignupPage business />;
};

export default SignupBusiness;
